import { HttpMethod } from '../../components/Common/useFetch';
import { RequestOptions } from '../../components/Common/useRequest';
import useUserOrKaEmployeeRequest from '../../components/Common/useUserOrEmployeeRequest';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface UpdateFieldAlyticsSite {
  id: string;
  blenderIds: string[];
}

const useUpdateFieldAlyticsSites = (options?: RequestOptions) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrKaEmployeeRequest<UpdateFieldAlyticsSite[]>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/sites`, method: HttpMethod.POST },
    options
  );
};

export default useUpdateFieldAlyticsSites;
